export default __webpack_public_path__ + "static/media/bookWeb1.93e615b5.jpg";